<template>
	<div id="manegeAddress">
		<!--头部-->
		<mt-header title="地址管理"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
 	    </mt-header>
 	    
 	    <!--地址-->
 	    <div class="manageAddresslist">
 	    	<!--<p>{{username}}</p>-->
 	    	<p v-if="addresslength==0" class="mt100 text-center font-size9 line-height25 bgfff colora9a9a9"><span class="colord6d6d6 mr10">———</span>点击下方添加新地址<span class="colord6d6d6 ml10">———</span></p>
 	    	<ul class="mAullist">
 	    		<li v-for="(item,index) in addressList">
 	    			<div class="mAliwrap ">
 	    				<p class="mAp1 clearfix font-size10"><span class="mApersonname">收货人：<i>{{item.name}}</i></span> <span class="mAphonenumber">{{item.phone}}</span></p>
 	    				
 	    				<p class="mAp2 font-size8"><span class="mAp2-span1">收货地址：</span><span class="mAp2-span2">{{item.address}}</span></p>
 	    				<p class="mAp3 mt8 clearfix">
 	    					<span class="mAselectdefault float-left">
 	    						<input type="radio" name="agree"  class="mr5 vm agreeRadio" :checked="addresslength==1?true:Boolean(item.flag-0)" @click="changedefault(item.id)"/>
 	    						<!--<input type='radio' id='mAddress' name="mAselect" />--><!--checked当地址长度为1时，默认打钩-->
 	    						<label for='mAddress' class="font-size8">设为默认</label>
 	    					</span>
    					    <span class="float-right font-size8">
	 	    					<!--<span class="mAbtnedit mAsize" @click="managetoedit(item.id)"><button>编辑</button></span>&nbsp;&nbsp;&nbsp;
	 	    					<span class="mAbtnselect mAsize" @click="deleteAction(item.id)"><button>删除</button></span>-->
	 	    					<span class="mAbtnedit mAsize" @click="managetoedit(item.id)"><a href="javascript:void(0)" class="impay1 tradState mr4 ml6">编辑</a></span>&nbsp;&nbsp;&nbsp;
	 	    					<span class="mAbtnselect mAsize" @click="deleteAction(item.id)"><a href="javascript:void(0)" class="impay1 tradState">删除</a></span>
	 	    					
 	    					</span>
 	    				</p>
 	    			</div>
 	    		</li>
 	    	</ul>
 	    </div>	
	<!--<p>{{addressLength}}</p>-->
	<!--添加新地址-->
		<p><input type="button" value="添加新地址" class="btnaddaddress" @click="toaddAddress"></p>
	</div>
</template>

<script>
	import { MessageBox } from 'mint-ui';
	import { Toast } from 'mint-ui';
	export default{
		data(){
			return{
			   //checkeds:true,   //默认地址变量
			   //flag:this.$route.query.flag, //点击我的页面地址管理传过来的标志
			   //sign:this.$route.query.sign,//实物订单地址选择点击管理时路由传过来的标志
			   page:1,  //请求地址页数
			   username:localStorage.getItem("username"),   //用户名
			   addressList:[],  //地址列表
			   addresslength:0, //地址数量
			   sign:localStorage.getItem("sign"),//地址管理跳转标志
			}
		},
		created:function(){
			this.showaddressList();
	    },
		methods:{
			returnBack(){
	          //this.$router.go(-1);
             // this.$router.push({path: "/UserCenter"}); 
//           if(this.sign=='select'){//地址管理返回时判断
//           	this.$router.push({path: "/UserCenter/selectAddress"}); 
//           }else if(this.flag=='usercenter'){
//           	this.$router.push({path:"/UserCenter"});
//           }else{
//           	//this.$router.push({path: "/UserCenter"});
//           	this.$router.go(-1);
//           }
             if(this.sign=='select'){
             	this.$router.push({path: "/UserCenter/selectAddress"});
             }else if(this.sign=='center'){
             	this.$router.push({path:"/UserCenter"});
             }else{
             	this.$router.go(-1);
             }
            
	        },
	        deleteAction(mid){
	        	MessageBox.confirm('',{message:'是否确定删除该地址?', title:'提示'}).then(action => {
             //   删除
//	        	this.addressList.splice(index, 1);	
                 this.deleteAction2(mid);
                 },
	             action=>{
//	             	console.log('取消了删除操作');
	             },
	        	);
	        },
	        	        
	        //删除地址按钮
	        deleteAction2(mid){
	        	this.$http.post(this.URL_PREFIX+"/user/deleteAddressById.net",{id:mid})
			  	  .then((res) =>{
//			  	   console.log(res.data.code);
                   if(res.data.code!=200){
                   	 Toast(res.data.msg);
                   }else{
                   	//window.location.reload(true);//强制刷新
                   	this.showaddressList();//从新获取地址数据
                   }
			  	  });
	        },
	        
	        //点击添加新地址跳转函数
	        toaddAddress(){
	           localStorage.setItem("addresslength",this.addresslength);
	           this.$router.push("/UserCenter/addAddress");
	        },
	        
	        //点击编辑时传地址ID到编辑页面
	        managetoedit(addressid){
//	        	localStorage.setItem("addressids",addressid);
	        	//修改
//	           this.$router.push({path: "/UserCenter/addAddress"});
               this.$router.push({path: "/UserCenter/addAddress",query: {editId:addressid}});
//             this.$router.push('/UserCenter/addAddress?editId='+addressid);
	        },

	        //选择默认地址按钮
	        changedefault(defauleid){
                this.$http.post(this.URL_PREFIX+"/user/updateAddressFlag.net",{id:defauleid,flag:1})
			  	  .then((res) =>{
                   if(res.data.code!=200){
                   	 Toast(res.data.msg);
                   }else{
                   }
			  	  });
	    	},
	    	
            //请求地址
	    	showaddressList(){
	    		this.$http.post(this.URL_PREFIX+"/user/findAddressAll.net",{uid:this.username,page:this.page,rows:25})
			  	  .then((res) =>{
			  	   this.addressList=res.data.rows;
//			  	   console.log('请求回来的地址长度');
//			  	   console.log(res.data.rows.length);
			  	   this.addresslength=res.data.rows.length;
			  	   if(res.data.rows.length==1){ //如果地址长度等于1，设为默认地址
			  	   	   let defauleid=res.data.rows[0].id;
			  	   	   this.changedefault(defauleid);
//			  	   	   this.showaddressList();
			  	   }
//			  	   console.log(res.data.rows.length);
//			  	   console.log(this.addressList);
			  	  });
	    	}
		}
		
	}
</script>

<style scoped="scoped">
	@import "../../../static/css/user.css";
.btnaddaddress{
    width: 100%;
    height: 40px;
    background: #ff8920;
    color: #fff;
    font-size: 1.0rem;
    border: none;
    line-height: 40px;
    position: fixed;
    bottom: 0;
}
.manageAddresslist{
	margin-top: 40px;
}
.mAullist li{
    border-bottom: 1px solid #e0e0e0;
}
.mAliwrap{
	padding: 10px 10px 15px 10px;
}
.mApersonname{
	float: left;
}
.mAphonenumber{
	float: right;
}
.mAp1{
	margin-bottom: 8px;
}
/*.mAdefault{
	margin-bottom: 4px;
	color: #ff8900;
}*/
.mAp2-span3{
	margin-left: 5px;
}
.mAsize{
	width: 20px;
	height: 15px;
}
#manegeAddress .impay1{
    border: 1px solid #ff8900;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    color: #ff8900;
    font-size: 0.9rem;
    text-align: center;
    padding: 2px 8px;
    margin-top: 7px;
}
#manegeAddress .tradState{color: #ff8900;border:1px solid #ff8900;}
/*.mAbtnedit button{
	border-color: #ff8920;
}*/
</style>


// WEBPACK FOOTER //
// src/views/UserCenter/manageAddress.vue